import React from "react";
import { Modal, Row, Col } from "react-bootstrap";

import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
} from "../../../../constants";
import ButtonWithToolTip from "../../../../shared/components/Buttons/ButtonWithToolTip";

const ConfirmationModal = (props) => {
  const {
    size = "md",
    title,
    children,
    isLoading = false,
    isConfirmationModal,
    isHtmlMessage = false,
    toggleConfirmationModal,
    message = "Are you sure you want to delete this item(s)?",
    // Discard Button
    isDiscardButton = false,
    handleDiscardButtonClick,
    discardButtonText = buttonNameConstants.DISCARD,
    discardButtonToolTipBody = EMPTY_STRING,
    // No Button
    isNoButton = true,
    handleNoButtonClick,
    noButtonToolTipBody = EMPTY_STRING,
    noButtonText = buttonNameConstants.NO,
    // Yes Button
    yesButtonType = false,
    handleYesButtonClick,
    yesButtonText = buttonNameConstants.YES,
    yesButtonToolTipBody = EMPTY_STRING,
  } = props;

  return (
    <Modal
      size={size}
      animation={true}
      centered
      backdrop="static"
      show={isConfirmationModal}
      onHide={toggleConfirmationModal}
      className={"nested-modal-z-index"}
      backdropClassName={"nested-modal-z-index"}
    >
      {title && (
        <Modal.Header closeButton className="pb-0">
          <Modal.Title className="d-flex align-items-center">
            <span>{title}</span>
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        <Row className="m-0 p-0">
          <Col md={12} className="m-0 pe-0">
            <Row className="m-0 p-0 h-100">
              <Col
                md={12}
                className={
                  isHtmlMessage
                    ? title
                      ? "p-0 mt-2 stolen-card-text pb-4 fs-5 text-start"
                      : "p-0 mt-2 stolen-card-text py-4 fs-5 text-start"
                    : "p-0 mt-2 stolen-card-text d-flex justify-content-center py-4 fs-4 text-start"
                }
              >
                {children}
                {isHtmlMessage ? (
                  <div dangerouslySetInnerHTML={{ __html: message }} />
                ) : (
                  message
                )}
              </Col>
              {/* Modal buttons */}
              <Col md={12} className="mt-auto p-0 d-flex gap-2">
                {isNoButton && (
                  <ButtonWithToolTip
                    key="no-button"
                    type="button"
                    toolTipRootClassName="w-100"
                    className="w-100"
                    label={noButtonText}
                    isDisabled={isLoading}
                    toolTipBody={noButtonToolTipBody}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    handleClick={() => {
                      handleNoButtonClick();
                    }}
                  ></ButtonWithToolTip>
                )}
                {isDiscardButton && (
                  <ButtonWithToolTip
                    key="discard-button"
                    type="button"
                    toolTipRootClassName="w-100"
                    className="w-100"
                    isDisabled={isLoading}
                    label={discardButtonText}
                    toolTipBody={discardButtonToolTipBody}
                    handleClick={handleDiscardButtonClick}
                  ></ButtonWithToolTip>
                )}
                <ButtonWithToolTip
                  key="yes-button"
                  type="button"
                  toolTipRootClassName={"w-100"}
                  className={
                    isNoButton || isDiscardButton ? "w-100" : "mx-auto w-50" // to make sure if there's just one button then it is centered aligned and not taking full width of modal
                  }
                  handleClick={() => {
                    handleYesButtonClick();
                  }}
                  label={yesButtonText}
                  isLoading={isLoading}
                  isDisabled={isLoading}
                  toolTipBody={yesButtonToolTipBody}
                  buttonType={yesButtonType ? yesButtonType : ""}
                ></ButtonWithToolTip>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
